export default ['loan', 'saving', 'social_fund'];
